import { render, staticRenderFns } from "./LinkCodeBox.vue?vue&type=template&id=44fe6ba2&scoped=true&"
import script from "./LinkCodeBox.vue?vue&type=script&lang=js&"
export * from "./LinkCodeBox.vue?vue&type=script&lang=js&"
import style0 from "./LinkCodeBox.vue?vue&type=style&index=0&id=44fe6ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fe6ba2",
  null
  
)

export default component.exports